import * as React from 'react'
import { lightTheme } from '@/customTheme'

interface InspectorSubheaderProps {
  label: string
  capitalize?: boolean
  style?: React.CSSProperties
}

function InspectorSubheader({ label, capitalize, style }: InspectorSubheaderProps) {
  const displayLabel = capitalize
    ? label.charAt(0).toUpperCase() + label.slice(1)
    : label

  return (
    <span
      style={{
        ...lightTheme.typography.Small14Semibold,
        color: lightTheme.colors.text?.text_black_title ?? lightTheme.colors.blackGray,
        ...style,
      }}
    >
      {displayLabel}
    </span>
  )
}

export default InspectorSubheader
